export enum Status {
  DRAFT = "DRAFT",
  ARCHIVED = "ARCHIVED",
  PENDING_VALIDATION = "PENDING_VALIDATION",
  VALIDATED = "VALIDATED"
}
export enum ApoStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  INACTIVE = "INACTIVE"
}
export enum Type {
  TAX = "TAX",
  ACC = "ACC",
  OTH = "OTH"
}
export enum ApprovalType {
  GROUP = "GROUP",
  COMPANY = "COMPANY"
}
export enum businessIdentifierType {
  TAXATION = "TAXATION",
  ACCOUNTING = "ACCOUNTING",
  OTHER = "OTHER"
}

export class businessEntityIdentifierType{
  "name": string
  "description": string
  "type": businessIdentifierType
  "row_id": string
}
export class businessEntityIdentifierTypes{
  "business-entity-identifier-types":businessEntityIdentifierType[]
}
export class group {
  "modificationStatus": Status
  "representingCompanyAllianceIdentifier": string
  "groupTypes": string
  "representingCompanyId": string
  "endDate": string
  "groupTypeCode": string
  "allianceIdentifier": string
  "name": string
  "row_id": string
  "startDate": string
}
export class groups {
  "groups": group[]
}
export class companyIdentifier {
  "companyAllianceIdentifier": string
  "linkedCompanyId": string
  "companyIdentifierKeyName": string
  "endDate": string
  "companyIdentifierTypeId": string
  "row_id": string
  "value": string
  "startDate": string
}
export class companyIdentifiers {
  "company-identifiers": companyIdentifier[]
}
export class company {

  "legalName": string
  "companyStatusId": string
  "noMdm": boolean
  "endDate": string
  "allianceIdentifier": string
  "companyStatusCode": string
  "workflowStatus": string
  "termsSigned": boolean
  "startDate": string
  "rowId": string

}
export class companies {
  "companies": company[]
}
export class groupAssignment {
  "companyAllianceIdentifier": string
  "identifier": string
  "companyAllianceLegalName": string
  "validityStartDate": string
  "groupstringCode": string
  "groupId": string
  "groupTypeId": string
  "apoStatus": ApoStatus
  "groupStatus": Status
  "validityEndDate": string
  "groupAllianceIdentifier": string
  "groupName": string
  "companyId": string
  "row_id": string
  "status": Status
}

export class groupAssignments {
  "group-assignments": groupAssignment[]
}
export class groupIdentifier {
  "groupName": string
  "endDate": string
  "groupId": string
  "groupIdentifierKeyId": string
  "row_id": string
  "value": string
  "startDate": string
  "groupIdentifierKeyName": string
  "groupAllianceIdentifier": string
}

export class groupIdentifiers {
  "group-identifiers": groupIdentifier[]
}
export class businessEntity {
  "modificationStatus": Status
  "companyAllianceIdentifier": string
  "identifier": string
  "companyId": string
  "isHQ": string
  "companyLegalName": string
  "row_id": string
}
export class businessEntities {
  "business-entities": businessEntity[]
}
export class businessEntityIdentifier {
  "businessEntityIdentifierTypeName": string
  "endDate": string
  "businessEntityId": string
  "businessEntityAllianceIdentifier": string
  "row_id": string
  "businessEntityIdentifierTypeId": string
  "value": string
  "startDate": string
}
export class businessEntityIdentifiers {
  "business-entity-identifiers": businessEntityIdentifier[]
  "count": number
  "maxPage": number
  "page": number
  "pageCount": number
}
export class bvdInterface {
  "result": string
  "national-id": string
  "country": string
  "address": string
  "city": string
  "name": string
  "row_id": string
  "bvd-id": string
}
export class CompanyIdentifierkey{
  "name": string
  "description": string
  "type": Type
  "row_id": string
}
export class CompanyIdentifierkeys {
  "company-identifier-keys": CompanyIdentifierkey[]
}
export class CompanyName{
    "companyAllianceIdentifier": string
    "companyNameTypeName": string
    "companyId": string
    "endDate": string
    "row_id": string
    "companyNameTypeId": string
    "value": string
    "startDate": string  
}
export class CompanyNames{
  "count": number
  "maxPage": number
  "page": number
  "pageCount": number
  "company-names":CompanyName[]
  
}
export class CompanyStatus{
  
    "code": string
    "description": string
    "row_id": string
  }
export class CompanyStatuses{
  "company-names":CompanyStatus[]
}
export class siteAssignment{
  
    "identifier": string
    "isHQ": string
    "validityStartDate": string
    "businessEntityCompanyAllianceIdentifier": string
    "reaIdentifier": string
    "businessEntityId": string
    "validityEndDate": string
    "rowId": string
    "site": any
    "businessEntityCompanyLegalName": string
    "businessEntityAllianceIdentifier": string
    "businessEntityCompanyId": string
    "status": Status
  
}
export class siteAssignments{
  "site-assignments":siteAssignment[]
}

export class groupType{
    "groupTypeCode": string
    "row_id": string
    "groupTypeDescription": string
}

export class groupTypes{
  "group-types":groupType[]
}

export class groupIdentifierKey{
  "name": string
  "description": string
  "row_id": string
}

export class groupIdentifierKeys{
  "group-identifier-keys":groupIdentifierKey[]
}

export class approvalScope{
  "decription": string
  "code": string
  "row_id": string
}

export class approvalScopes{
  "approval-scopes":approvalScope[]
} 

export class groupApproval{
  "identifier": string
  "scopeId": string
  "validityStartDate": string
  "groupId": string
  "groupPwo": string
  "type": ApprovalType
  "validityEndDate": string
  "approvalModificationStatus": Status
  "groupName": string
  "statusId": string
  "scopeCode": string
  "groupIdentifier": string
  "row_id": string
}

export class groupApprovals{
  "group-approvals":groupApproval[]
}

export class companyApproval{
  "identifier": string
  "scopeId": string
  "validityStartDate": string
  "clientCompanyCode": string
  "clientCompanyId": string
  "type": ApprovalType
  "validityEndDate": string
  "clientCompanyIdentifier": string
  "companiesId": string
  "clientCompanyLegalName": string
  "approvalModificationStatus": Status
  "companyIdentifier": string
  "statusId": string
  "scopeCode": string
  "row_id": string
  "statusCode": string
}
export class companyApprovals{
  "company-approvals":companyApproval[]
}

export class approvalStatus{
  "identifier": string
  "scopeId": string
  "validityStartDate": string
  "clientCompanyCode": string
  "clientCompanyId": string
  "type": ApprovalType
  "validityEndDate": string
  "clientCompanyIdentifier": string
  "companiesId": string
  "clientCompanyLegalName": string
  "approvalModificationStatus": Status
  "companyIdentifier": string
  "statusId": string
  "scopeCode": string
  "row_id": string
  "statusCode": "string"
}
export class approvalStatuses{
  "company-approvals":approvalStatus[]
}
export class companyNameType{
  "name": string
  "description": string
  "row_id": string
}

export class payingCompany{
  "legalName": string
  "identifier": string
  "code": string
  "row_id": string
}
export class payingCompanies{
  "paying-company":payingCompany[]
}

export class companyNameTypes{
  "company-name-types":companyNameType[]
} 

export class groupAssignmentType{
  "groupAssignementTypeCode": string
  "groupAssignementTypeDescription": string
  "row_id": string
}

export class groupAssignmentTypes{
  "group-assignment-types":groupAssignmentType[]
}